import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import css from "./DishProductModal.module.css";
import { dishProductsAction } from "../../../../store/slices/dishes-slices";
import { DishUpdateProductModal } from "../DishAddProductModal/DishUpdateProductModal";
import { ArrowDownToLine, ArrowUpToLine, Pencil } from "lucide-react";
import { MdCancel } from "react-icons/md";

const DishProductModal = ({ dishProduct, index }) => {
  const dispatch = useDispatch();
  const {
    id,
    name,
    weight,
    cost,
    weightNetto,
    productId,
    energy,
    proteins,
    fats,
    carbohydrates,
  } = dishProduct;
  const { dishProductsForModalArray } = useSelector(
    (store) => store.dishProducts
  );

  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const displayName = name[currentLanguage] || name["en"];
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);

  const handleUpdateClick = () => {
    setIsOpenUpdate(true);
  };

  const deleteDishProduct = () => {
    dispatch(dishProductsAction.removeDishProductForModal(id));
  };

  const handleUpClick = () => {
    // if index is 1, do nothing otherwise change the index and make the array don't use dispatch
    if (index === 0) return;
    const newArray = [...dishProductsForModalArray];
    newArray.splice(index, 1);
    newArray.splice(index - 1, 0, dishProductsForModalArray[index]);
    dispatch(dishProductsAction.updateDishProductsForModal(newArray));
  };

  const handleDownClick = () => {
    if (index === dishProductsForModalArray.length - 1) return;
    const newArray = [...dishProductsForModalArray];
    newArray.splice(index, 1);
    newArray.splice(index + 1, 0, dishProductsForModalArray[index]);
    dispatch(dishProductsAction.updateDishProductsForModal(newArray));
  };

  return (
    <section className={css.wrap}>
      <div className={css.product}>
        {displayName}

        {/* nutrients grid */}
        <div className={css.nutritionGrid}>
          <div className={css.nutritionItem}>
            <span className={css.nutritionLabel}>E:</span>
            <span className={css.nutritionValue}>{energy || 0} kcal</span>
          </div>
          <div className={css.nutritionItem}>
            <span className={css.nutritionLabel}>P:</span>
            <span className={css.nutritionValue}>{proteins || 0} g</span>
          </div>
          <div className={css.nutritionItem}>
            <span className={css.nutritionLabel}>F:</span>
            <span className={css.nutritionValue}>{fats || 0} g</span>
          </div>
          <div className={css.nutritionItem}>
            <span className={css.nutritionLabel}>C:</span>
            <span className={css.nutritionValue}>{carbohydrates || 0} g</span>
          </div>
        </div>
      </div>
      <div className={css.weight}>{weight}</div>
      <div className={css.weightNetto}>{weightNetto}</div>
      <div className={css.price}>{cost}</div>
      <div className={css.index}>
        {index > 0 && <ArrowUpToLine size={16} onClick={handleUpClick} />}
        {index !== dishProductsForModalArray.length - 1 && (
          <ArrowDownToLine size={16} onClick={handleDownClick} />
        )}
      </div>
      <div className={css.actions}>
        <div className={css.updateButton} onClick={handleUpdateClick}>
          <Pencil size={16} />
        </div>
        <div className={css.deleteButton} onClick={deleteDishProduct}>
          <MdCancel size={16} />
        </div>
      </div>

      {isOpenUpdate && (
        <DishUpdateProductModal
          productId={productId || id}
          setDishProductUpdateOpen={setIsOpenUpdate}
          weight={weight}
          weightNetto={weightNetto}
        />
      )}
    </section>
  );
};

export default DishProductModal;
